import { DashboardRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";

export const dashboardService = {

    getYearSalesByMonth: async (organisationId: string) => {
        return await fetchRequest({
            route: `${DashboardRoutesEnum.DASHBOARD_GET_YEAR_SALES_BY_MONTH}/${organisationId}`,
            method: "GET"
        });
    },

    getMonthSalesByWeek: async (organisationId: string) => {
        return await fetchRequest({
            route: `${DashboardRoutesEnum.DASHBOARD_GET_MONTH_SALES_BY_WEEK}/${organisationId}`,
            method: "GET"
        });
    },

    getWeekSalesByDay: async (organisationId: string) => {
        return await fetchRequest({
            route: `${DashboardRoutesEnum.DASHBOARD_GET_WEEK_SALES_BY_DAY}/${organisationId}`,
            method: "GET"
        });
    },

    getTodaySalesByHour: async (organisationId: string) => {
        return await fetchRequest({
            route: `${DashboardRoutesEnum.DASHBOARD_GET_TODAY_SALES_BY_HOUR}/${organisationId}`,
            method: "GET"
        });
    },

    getTopProductsStats: async (organisationId: string) => {
        return await fetchRequest({
            route: `${DashboardRoutesEnum.DASHBOARD_GET_TOP_PRODUCTS_STATS}/${organisationId}`,
            method: "GET"
        });
    },

    getAverageSalesByHour: async (organisationId: string) => {
        return await fetchRequest({
            route: `${DashboardRoutesEnum.DASHBOARD_GET_AVERAGE_SALES_BY_HOUR}/${organisationId}`,
            method: "GET"
        });
    },

    getAverageSalesByDayOfWeek: async (organisationId: string) => {
        return await fetchRequest({
            route: `${DashboardRoutesEnum.DASHBOARD_GET_AVERAGE_SALES_BY_DAY_OF_WEEK}/${organisationId}`,
            method: "GET"
        });
    },

    getSellerPerformance: async (organisationId: string, dateRange?: { startDate: Date | null, endDate: Date | null }) => {
        return await fetchRequest({
            route: `${DashboardRoutesEnum.DASHBOARD_GET_SELLER_PERFORMANCE}/${organisationId}`,
            method: "GET"
        });
    },

    getOrganisationMonthlyRevenueAndNextInvoiceDate: async (organisationId: string) => {
        return await fetchRequest({
            route: `${DashboardRoutesEnum.DASHBOARD_GET_ORGANISATION_MONTHLY_REVENUE_AND_NEXT_INVOICE_DATE}/${organisationId}`,
            method: "GET"
        });
    }
    
};
